import { fetchAllSportCourses, fetchSportCourseInfo } from "@/api/landing";
import { generateRandomGradient } from "@/utils/gradients";

export default {
  namespaced: true,
  state: {
    allSportCourses: {
      data: [],
      pagination: {
        currentPage: 1,
        total: 0,
        perPage: 10,
        lastPage: 1,
        nextPage: null,
      },
    },
    sportCourseInfo: {},
    gradients: [],
  },

  mutations: {
    SET_ALL_SPORT_COURSES(state, payload) {
      state.allSportCourses.data = payload.data;
      state.allSportCourses.pagination = {
        currentPage: payload.current_page,
        total: payload.total,
        perPage: payload.per_page,
        lastPage: payload.last_page,
        nextPage: payload.next_page_url,
      };

      if (
        state.gradients.length === 0 ||
        state.gradients.length !== payload.data.length
      ) {
        state.gradients = payload.data.map((_, index) =>
          generateRandomGradient(index)
        );
      }
    },
    SET_SPORT_COURSE_INFO(state, courseInfo) {
      state.sportCourseInfo = courseInfo;
    },
    SET_SPORT_COURSE_GRADIENTS(state, gradients) {
      state.gradients = gradients;
    },
  },

  actions: {
    loadAllSportCourses({ commit }, { page = 1, filters = {} } = {}) {
      return fetchAllSportCourses({ page, ...filters })
        .then((response) => {
          const coursesWithBackground = {
            ...response.data,
            data: response.data.data.map((course, index) => ({
              ...course,
              background: generateRandomGradient(index),
            })),
          };
          commit("SET_ALL_SPORT_COURSES", coursesWithBackground);
        })
        .catch((error) => {
          console.error("Ошибка загрузки спортивных курсов:", error);
          return Promise.reject(error);
        });
    },

    loadSportCourseInfo({ commit }, courseId) {
      return fetchSportCourseInfo(courseId)
        .then((response) => {
          commit("SET_SPORT_COURSE_INFO", response.data.course_info);
        })
        .catch((error) => {
          console.error(
            "Ошибка загрузки информации о спортивном курсе:",
            error
          );
          return Promise.reject(error);
        });
    },
  },

  getters: {
    getAllCourses: (state) => state.allSportCourses,
    getPagination: (state) => state.allSportCourses.pagination,
    getCourseInfo: (state) => state.sportCourseInfo,
    getGradients: (state) => state.gradients,
  },
};
